import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative bg-[#1A0B10] text-[#FAF5EE] min-h-[90vh] flex flex-col justify-center overflow-hidden pt-16 pb-16 px-5" data-id="element-81">
      {/* Subtle phone glow effect */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 0.4,
      scale: 1
    }} transition={{
      duration: 4,
      repeat: Infinity,
      repeatType: 'reverse',
      ease: 'easeInOut'
    }} className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#5C1A2B] blur-[120px] rounded-full pointer-events-none" data-id="element-82" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-8 inline-flex items-center gap-2" data-id="element-84">
          <span className="h-px w-6 bg-[#C86B5E]" data-id="element-85"></span>
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#C86B5E] font-medium" data-id="element-86">
            El Manual de las Migajas
          </span>
          <span className="h-px w-6 bg-[#C86B5E]" data-id="element-87"></span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="font-serif leading-[1.05] mb-8 text-[#FAF5EE] text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-88">
          <span className="block" data-id="element-89">¿Cuánto tiempo más</span>
          <span className="block italic text-[#C86B5E]" data-id="element-90">vas a humillarte</span>
          <span className="block" data-id="element-91">esperando un mensaje</span>
          <span className="block italic text-[#C86B5E]" data-id="element-92">
            que no va a llegar?
          </span>
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-base md:text-lg font-light text-[#E0D5C1] max-w-xl mx-auto mb-10 leading-relaxed" data-id="element-93">
          Él no está "confundido" ni "asustado".{' '}
          <span className="text-[#FAF5EE] font-medium" data-id="element-94">
            Simplemente no te quiere lo suficiente.
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="max-w-xl mx-auto text-left bg-[#250911]/60 p-6 md:p-8 border-l-2 border-[#C86B5E] backdrop-blur-sm mb-10" data-id="element-95">
          <p className="font-serif italic text-lg md:text-xl text-[#C86B5E] leading-snug" data-id="element-96">
            "Son las 3:14 AM. Llevas una hora revisando si está 'En línea'.
            Subió una historia riendo. A ti no te contestó hace 8 horas."
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-97">
          <a href="#offer" className="inline-block w-full sm:w-auto bg-[#C86B5E] hover:bg-[#b05a4e] text-white font-medium py-4 px-8 tracking-wider uppercase text-xs sm:text-sm transition-all duration-300 shadow-lg shadow-[#C86B5E]/20 hover:shadow-[#C86B5E]/40" data-id="element-98">
            Quiero mi dignidad de vuelta
          </a>
          <p className="mt-4 text-xs text-[#8A6A6A] tracking-wide" data-id="element-99">
            Acceso inmediato · $89 MXN
          </p>
        </motion.div>
      </div>
    </section>;
}